import { useSelector } from 'react-redux';
import Button from '../../../../components/Button';
import { createRootModal } from '../../RootModal';

import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import './FreezeCard.scss';

const FreezeCard = createRootModal(({ handleClose }) => {
	const { mode = true } = useSelector(
		state => state.app.modals.find(modal => modal.tag === 'FreezeCard')?.outsideParams || {}
	);
	console.log('MODE: ', mode);

	const isFreeze = mode;

	const actionClick = async () => {
		const resolveFunct = response => {
			console.log('Freeze unfreeze');
		};

		const rejectFunct = () => {
			HelperService.showNotification({
				type: 'error',
				title: t('Error'),
			});
		};

		const action = () => {
			console.log('FREEZE');
			return true;
		};

		try {
			// const result = await RequestService.ChangeCardFreezeStatus(mode);

			HelperService.confirmPin({
				requestMethod: action,
				resolveFunc: rejectFunct,
				rejectFunt: rejectFunct,
			});
			console.log('Result: ');

			handleClose();
		} catch (e) {
			console.error('Freeze in action failed: ', e);
		}
	};

	return (
		<div className='FreezeCard'>
			<div className='FreezeCard__content'>
				<div className='FreezeCard__content-text'>
					<p className='FreezeCard__content-regular'>Description</p>
				</div>

				<div className='FreezeCard__content-text'>
					<p className='FreezeCard__content-bold'>Subtitle</p>
					<p className='FreezeCard__content-regular'>Description</p>
				</div>
				<div className='FreezeCard__button'>
					<Button onClick={() => actionClick()}>{isFreeze ? 'Freeze card' : 'Unfreeze card'}</Button>
				</div>
			</div>
		</div>
	);
});

export default FreezeCard;
